import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BingoComponent } from './bingo/bingo.component';
import { InformesComponent } from './informes/informes.component';
import { MapaComponent } from './mapa/mapa.component';
import { TableComponent } from './table/table.component';
import { ErrorsComponent } from './errors/errors.component';
import { HistorialComponent } from './historial/historial.component';
import { VariablesComponent } from './variables/variables.component';
import { AlertasComponent } from './alertas/alertas.component';
import { GraficasComponent } from './graficas/graficas.component';
import { GraficasConjuntasComponent } from './graficas-conjuntas/graficas-conjuntas.component';
import { EverisListadoComponent } from './everis-listado/everis-listado.component';
import { HomeComponent } from './home/home.component';
import { DireccionComponent } from './direccion/direccion.component';
import { EstadisticasEverisComponent } from './estadisticas-everis/estadisticas-everis.component';
import { DireccionUniqueComponent } from './direccion-unique/direccion-unique.component';
import { ParkingComponent } from './parking/parking.component';
import { PagosparkingComponent } from './pagosparking/pagosparking.component';
import { ArqueappComponent } from './arqueapp/arqueapp.component';
import { FactComponent } from './fact/fact.component';
import { OcupacionComponent } from './ocupacion/ocupacion.component';
import { ConcurrenciaComponent } from './concurrencia/concurrencia.component';
import { CuadranteComponent } from './cuadrante/cuadrante.component';
import { ReservasParkingComponent } from './reservas-parking/reservas-parking.component';
import { CalllogComponent } from './calllog/calllog.component';
import { FactDifComponent } from './fact-dif/fact-dif.component';
import { HerramientasComponent } from './herramientas/herramientas.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { PresencialComponent } from './presencial/presencial.component';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { SlaveComponent } from './slave/slave.component';
import { ProduccionComponent } from './produccion/produccion.component';
import { IncidenciasComponent } from './incidencias/incidencias.component';
import { BingoeComponent } from './bingoe/bingoe.component';
import { RangoshoraComponent } from './rangoshora/rangoshora.component';
import { VentasComponent } from './ventas/ventas.component';
import { CuadranteParkingComponent } from './cuadrante-parking/cuadrante-parking.component';
import { AcuerdosComponent } from './acuerdos/acuerdos.component';
import { CrearAcuerdoComponent } from './crear-acuerdo/crear-acuerdo.component';
import { EditarAcuerdoComponent } from './editar-acuerdo/editar-acuerdo.component';
import { CrearValorComponent } from './crear-valor/crear-valor.component';
import { FactplazaComponent } from './factplaza/factplaza.component';
import { FactbalisaComponent } from './factbalisa/factbalisa.component';
import { ZktecoComponent } from './zkteco/zkteco.component';
import { ZkregistrosComponent } from './zkregistros/zkregistros.component';
import { ConsultarAcuerdosComponent } from './consultar-acuerdos/consultar-acuerdos.component';

const routes: Routes = [
  // { path: '', component: DashboardComponent },
  { path: '', component: HomeComponent },
  { path: 'bingo', component: BingoComponent },
  { path: 'informes', component: InformesComponent },
  { path: 'mapa', component: MapaComponent },
  { path: 'table', component: TableComponent },
  { path: 'table', component: TableComponent },
  { path: 'graficas_conjuntas', component: GraficasConjuntasComponent },
  { path: 'graficas', component: GraficasComponent },
  { path: 'errors', component: ErrorsComponent },
  { path: 'historial', component: HistorialComponent },
  { path: 'variables', component: VariablesComponent },
  { path: 'everis', component: EverisListadoComponent },
  { path: 'estadisticas_everis', component: EstadisticasEverisComponent },
  { path: 'alertas', component: AlertasComponent },
  { path: 'direccion', component: DireccionComponent },
  { path: 'direccion_unique', component: DireccionUniqueComponent },
  { path: 'parking', component: ParkingComponent },
  { path: 'arqueapp', component: ArqueappComponent },
  { path: 'pagos', component: PagosparkingComponent },
  { path: 'fact', component: FactComponent },
  { path: 'ocupacion', component: OcupacionComponent },
  { path: 'concurrencia', component: ConcurrenciaComponent },
  { path: 'cuadrante', component: CuadranteComponent },
  { path: 'reservas', component: ReservasParkingComponent },
  { path: 'calllog', component: CalllogComponent },
  { path: 'presencial', component: PresencialComponent },
  { path: 'notificaciones', component: NotificacionesComponent },
  { path: 'fact_dif', component: FactDifComponent },
  { path: 'factbalisa', component: FactbalisaComponent },
  { path: 'factplaza', component: FactplazaComponent },
  { path: 'herramientas', component: HerramientasComponent },
  { path: 'documentacion', component: DocumentationComponent },
  { path: 'slave', component: SlaveComponent },
  { path: 'produccion', component: ProduccionComponent },
  { path: 'incidencias', component: IncidenciasComponent },
  { path: 'bingoe', component: BingoeComponent },
  { path: 'rangoshora', component: RangoshoraComponent },
  { path: 'ventas', component: VentasComponent },
  { path: 'cuadrante_parking', component: CuadranteParkingComponent },
  { path: 'acuerdos', component: AcuerdosComponent },
  { path: 'crear_acuerdos', component: CrearAcuerdoComponent },
  { path: 'editar_acuerdos', component: EditarAcuerdoComponent },
  { path: 'consultar_acuerdos', component: ConsultarAcuerdosComponent },
  { path: 'crear_valor', component: CrearValorComponent },
  { path: 'zkteco', component: ZktecoComponent },
  { path: 'zkregistros', component: ZkregistrosComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
